import { createSelector } from '@ngrx/store';
import { AppState } from 'sp-mark/redux';
import { RouterState } from 'sp-mark/redux/router/router.reducers';

const selectFeature = (appState: AppState) => appState.router;

export const selectMenuSectionItems = createSelector(
  selectFeature,
  (state: RouterState) => state ? state.menuSectionItems : undefined
);

export const selectRoutingLog = createSelector(
  selectFeature,
  (state: RouterState) => state ? state.routingLog : undefined
);

export const selectActualPage = createSelector(
  selectFeature,
  (state: RouterState) => state ? state.routingLog[state.routingLog.length -1] : undefined
);
